// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.companiesContainer {
    color: #eee;
    padding-top: 0;
}

.companyCard {
position: relative;
    flex: 4 1;
    height: 180px;
    background-color: #282B30;
    cursor: pointer;
    overflow: hidden;
    width: 70%;
    float: left;
    padding: 10px;
    border: 1px solid #4b4e52;
    

}

.companyTitle {
    margin-top: 0;
    background-color: #0f1011 !important;
    width: 100%;
    font-weight: bold;
    top: 0;
}


.addNewNote {
    width: 89%;
    height: 180px;
    background-color: #282B30;
    cursor: pointer;
    padding: 12px;
    overflow: hidden;
    margin-bottom: 10px;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

}

.companiesContainer .addNewNote button {
    font-size: 50px;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    width: 100%;
    height: 100%;
    border-radius: 0 !important;
}

.companiesContainer .addNewNote button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}


.companyDetails .css-i4bv87-MuiSvgIcon-root{
    height:0.7 !important;
}
.cardHolder {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;

}

.companyName {
  width: 100%;
    position: absolute;
    vertical-align: top;
    height: 35px;
    padding: 10px 1px;
    top: 0;
    background-color: #0f1113;
    font-weight: bold;
    left: 0;
    font-size: 15px;
    text-align: center;
    white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
    

}
.companyDetails{
    margin-top: 60px;
    text-align: center;
}

.NoteTitle input {
    background-color: #282B30;
    width: 95%;
    height: 25px;
    color: #eee;
    padding: 5px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.NoteDescription textarea {
    background-color: #282B30;
    width: 95%;
    min-height: 180px;
    color: #eee;
    padding: 5px;
    margin-bottom: 10px;
    margin-top: 5px;
}

.addNoteBookButton {
    color: #eee !important;
    border-radius: 0 !important;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%) !important;
}

.addNoteBookButton:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%) !important;
}

.closeAddNoteButton {
    color: #eee !important;
    border-radius: 0 !important;
    background-color: #4b4e52 !important;

}

.closeAddNoteButton:hover {
    background-color: #696a6b !important;

}`, "",{"version":3,"sources":["webpack://./src/components/TicketingComponents/contract.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;AACA,kBAAkB;IACd,SAAO;IACP,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,aAAa;IACb,yBAAyB;;;AAG7B;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,WAAW;IACX,iBAAiB;IACjB,MAAM;AACV;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;;IAEnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,eAAe;IACf,iFAAiF;IACjF,WAAW;IACX,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,iFAAiF;AACrF;;;AAGA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;EACE,WAAW;IACT,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,MAAM;IACN,yBAAyB;IACzB,iBAAiB;IACjB,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB,gBAAgB;EAChB,uBAAuB;;;AAGzB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,4FAA4F;AAChG;;AAEA;IACI,4FAA4F;AAChG;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,oCAAoC;;AAExC;;AAEA;IACI,oCAAoC;;AAExC","sourcesContent":[".companiesContainer {\n    color: #eee;\n    padding-top: 0;\n}\n\n.companyCard {\nposition: relative;\n    flex: 4;\n    height: 180px;\n    background-color: #282B30;\n    cursor: pointer;\n    overflow: hidden;\n    width: 70%;\n    float: left;\n    padding: 10px;\n    border: 1px solid #4b4e52;\n    \n\n}\n\n.companyTitle {\n    margin-top: 0;\n    background-color: #0f1011 !important;\n    width: 100%;\n    font-weight: bold;\n    top: 0;\n}\n\n\n.addNewNote {\n    width: 89%;\n    height: 180px;\n    background-color: #282B30;\n    cursor: pointer;\n    padding: 12px;\n    overflow: hidden;\n    margin-bottom: 10px;\n\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.companiesContainer .addNewNote button {\n    font-size: 50px;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    width: 100%;\n    height: 100%;\n    border-radius: 0 !important;\n}\n\n.companiesContainer .addNewNote button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n\n\n.companyDetails .css-i4bv87-MuiSvgIcon-root{\n    height:0.7 !important;\n}\n.cardHolder {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    position: relative;\n\n}\n\n.companyName {\n  width: 100%;\n    position: absolute;\n    vertical-align: top;\n    height: 35px;\n    padding: 10px 1px;\n    top: 0;\n    background-color: #0f1113;\n    font-weight: bold;\n    left: 0;\n    font-size: 15px;\n    text-align: center;\n    white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n    \n\n}\n.companyDetails{\n    margin-top: 60px;\n    text-align: center;\n}\n\n.NoteTitle input {\n    background-color: #282B30;\n    width: 95%;\n    height: 25px;\n    color: #eee;\n    padding: 5px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n}\n\n.NoteDescription textarea {\n    background-color: #282B30;\n    width: 95%;\n    min-height: 180px;\n    color: #eee;\n    padding: 5px;\n    margin-bottom: 10px;\n    margin-top: 5px;\n}\n\n.addNoteBookButton {\n    color: #eee !important;\n    border-radius: 0 !important;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%) !important;\n}\n\n.addNoteBookButton:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%) !important;\n}\n\n.closeAddNoteButton {\n    color: #eee !important;\n    border-radius: 0 !important;\n    background-color: #4b4e52 !important;\n\n}\n\n.closeAddNoteButton:hover {\n    background-color: #696a6b !important;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
